import React from 'react'
import {About, Footer, Header, Skills, Testimonial, Work} from './container'
import {Example} from './components'
import {ScrollToTop} from './components'
import './App.scss'

const App = () => {
  return (
    <div className='app'>
        <Example />
        <ScrollToTop />
        <Header />
        <About />
        <Work />
        <Skills />
        <Testimonial />
        <Footer />
    </div>

  )
}

export default App